import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AdGroupPermissionsResponse } from './permission-api.types';
import { APP_ENVIRONMENT, AppEnvironment } from '@price-management-console/shared-ui';

@Injectable({
  providedIn: 'root',
})
export class PermissionApiService {
  private readonly http = inject(HttpClient);
  private readonly environment: AppEnvironment = inject(APP_ENVIRONMENT);

  getServiceEndpoint(endpoint: string): string {
    return this.environment.USING_ANGULAR_PROXY ? `/permission-api/${endpoint}` : `${this.environment.APIGEEX_HOST_URL}/${endpoint}`;
  }

  getPermissions(userId: string): Observable<AdGroupPermissionsResponse> {
    const headers = new HttpHeaders({
      userId: userId,
    });

    const params = new HttpParams()
      .set('applicationName', 'PRICING_MANAGEMENT_CONSOLE')
      .set('useCache', 'true');

    // The path should come environment.ts
    return this.http.get<AdGroupPermissionsResponse>(
      this.getServiceEndpoint(this.environment.APIGEE_PERMISSIONS_GET_ENDPOINT),
      {
        headers,
        params,
      }
    );
  }
}
